<template>
    <div>
        <p>
            <span class="has-text-weight-bold"
                >{{ $t("soap-text-note.subjective") }}:
            </span>
            <span>{{ note.subjective }}</span>
        </p>
        <p>
            <span class="has-text-weight-bold"
                >{{ $t("soap-text-note.objective") }}:
            </span>
            <span>{{ note.objective }}</span>
        </p>
        <p>
            <span class="has-text-weight-bold"
                >{{ $t("soap-text-note.analysis") }}:
            </span>
            <span>{{ note.analysis }}</span>
        </p>
        <p>
            <span class="has-text-weight-bold">{{ $t("soap-text-note.plan") }}: </span>
            <span>{{ note.plan }}</span>
        </p>
    </div>
</template>

<script>
export default {
    name: "soap-text-note",
    props: {
        note: {
            type: Object,
            required: true,
        },
    },
};
</script>